// // import React, { useState } from "react";
// // import { useNavigate } from "react-router-dom";
// // import "../CSS/rlogin.css";
// // import { ArrowLeft, Search } from "lucide-react";
// // import logo from "../assets/logo.png";

// // function RLogin() {
// //   const navigate = useNavigate();

// //   // Local form states
// //   const [role, setRole] = useState("Doctor");
// //   const [cid, setCid] = useState("");
// //   const [email, setEmail] = useState("");
// //   const [password, setPassword] = useState("");

// //   const handleLogin = async (e) => {
// //     e.preventDefault();

// //     const response = await fetch("/api/staff/login", {
// //       method: "POST",
// //       headers: { "Content-Type": "application/json" },
// //       body: JSON.stringify({ role, email, password }),
// //     });

// //     const data = await response.json();

// //     if (response.ok) {
// //       console.log("Login successful:", data);

// //       // 🔥 ROLE-BASED NAVIGATION
// //       if (role === "Doctor") {
// //         navigate("/doctortoken");        // Doctor → Detail.js
// //       } else {
// //         navigate("/patientregister");    // Receptionist → Register.js
// //       }

// //     } else {
// //       console.log("Login error:", data.message);
// //     }
// //   };

// //   return (
// //     <div className="staffloginpage-container">
// //       {/* ===== Header ===== */}
// //       <header className="staffloginpage-header">
// //         <div className="staffloginpage-header-left">
// //           <ArrowLeft size={20} className="staffloginpage-backicon" />
// //           <img src={logo} alt="Q-Less Logo" className="staffloginpage-logo" />
// //         </div>
// //       </header>

// //       {/* ===== Main Content ===== */}
// //       <main className="staffloginpage-main">
// //         <div className="staffloginpage-card">
// //           <div className="staffloginpage-card-header">
// //             <Search size={38} className="staffloginpage-searchicon" />
// //             <h2>Staff Portal</h2>
// //             <p>Enter your credentials to access the hospital system</p>
// //           </div>

// //           {/* ===== Login Form ===== */}
// //           <form className="staffloginpage-form" onSubmit={handleLogin}>
// //             <label htmlFor="role">Role</label>
// //             <select id="role" value={role} onChange={(e) => setRole(e.target.value)}>
// //               <option>Doctor</option>
// //               <option>Receptionist</option>
// //             </select>

// //             <label htmlFor="cid">CID Number</label>
// //             <input
// //               id="cid"
// //               type="text"
// //               placeholder="Enter your CID"
// //               value={cid}
// //               onChange={(e) => setCid(e.target.value)}
// //             />

// //             <label htmlFor="email">Email</label>
// //             <input
// //               id="email"
// //               type="email"
// //               placeholder="Enter your email"
// //               value={email}
// //               onChange={(e) => setEmail(e.target.value)}
// //             />

// //             <label htmlFor="password">Password</label>
// //             <input
// //               id="password"
// //               type="password"
// //               placeholder="Enter your password"
// //               value={password}
// //               onChange={(e) => setPassword(e.target.value)}
// //             />

// //             <button type="submit" className="staffloginpage-btn">
// //               Login
// //             </button>
// //           </form>
// //         </div>
// //       </main>

// //       {/* ===== Footer ===== */}
// //       <footer className="staffloginpage-footer">
// //         © 2025 Q-Less. All Rights Reserved.
// //       </footer>
// //     </div>
// //   );
// // }

// // export default RLogin;




// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "../CSS/rlogin.css";
// import { ArrowLeft, Search } from "lucide-react";
// import logo from "../assets/logo.png";

// function RLogin() {
//   const navigate = useNavigate();

//   // Local form states
//   const [role, setRole] = useState("Doctor");
//   const [cid, setCid] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     const response = await fetch("https://q-less.onrender.com/api/staff/login", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ role, email, password }),
//     });

//     const data = await response.json();

//     if (response.ok) {
//       console.log("Login successful:", data);

//       // ROLE BASED NAVIGATION
//       if (role === "Doctor") {
//         navigate("/doctortoken");
//       } else {
//         navigate("/patientregister");
//       }
//     } else {
//       console.log("Login error:", data.message);
//     }
//   };

//   return (
//     <div className="staffloginpage-container">
//       {/* ===== Header ===== */}
//       <header className="staffloginpage-header">
//         <div className="staffloginpage-header-left">
//           <ArrowLeft
//             size={20}
//             className="staffloginpage-backicon"
//             onClick={() => navigate("/")}
//             style={{ cursor: "pointer" }}
//           />
//           <img src={logo} alt="Q-Less Logo" className="staffloginpage-logo" />
//         </div>
//       </header>

//       {/* ===== Main Content ===== */}
//       <main className="staffloginpage-main">
//         <div className="staffloginpage-card">
//           <div className="staffloginpage-card-header">
//             <Search size={38} className="staffloginpage-searchicon" />
//             <h2>Staff Portal</h2>
//             <p>Enter your credentials to access the hospital system</p>
//           </div>

//           {/* ===== Login Form ===== */}
//           <form className="staffloginpage-form" onSubmit={handleLogin}>
//             <label htmlFor="role">Role</label>
//             <select
//               id="role"
//               value={role}
//               onChange={(e) => setRole(e.target.value)}
//             >
//               <option>Doctor</option>
//               <option>Receptionist</option>
//             </select>

//             <label htmlFor="cid">CID Number</label>
//             <input
//               id="cid"
//               type="text"
//               placeholder="Enter your CID"
//               value={cid}
//               onChange={(e) => setCid(e.target.value)}
//             />

//             <label htmlFor="email">Email</label>
//             <input
//               id="email"
//               type="email"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//             />

//             <label htmlFor="password">Password</label>
//             <input
//               id="password"
//               type="password"
//               placeholder="Enter your password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//             />

//             <button type="submit" className="staffloginpage-btn">
//               Login
//             </button>
//           </form>
//         </div>
//       </main>

//       {/* ===== Footer ===== */}
//       <footer className="staffloginpage-footer">
//         © 2025 Q-Less. All Rights Reserved.
//       </footer>
//     </div>
//   );
// }

// export default RLogin;


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../CSS/rlogin.css";
import { ArrowLeft, Search } from "lucide-react";
import logo from "../assets/logo.png";

function RLogin() {
  const navigate = useNavigate();

  const [role, setRole] = useState("Doctor");
  const [cid, setCid] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Error states
  const [cidError, setCidError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [serverError, setServerError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    let valid = true;

    // Reset previous errors
    setCidError("");
    setEmailError("");
    setPasswordError("");
    setServerError("");

    // CID Validation
    if (!cid.trim()) {
      setCidError("CID number is required.");
      valid = false;
    }

    if (!email.trim()) {
      setEmailError("Email is required.");
      valid = false;
    }

    if (!password.trim()) {
      setPasswordError("Password is required.");
      valid = false;
    }

    if (!valid) return;

    // API Request
    const response = await fetch("https://q-less.onrender.com/api/staff/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ role, cid, email, password }),
    });

    const data = await response.json();

    if (response.ok) {
      if (role === "Doctor") navigate("/doctortoken");
      else navigate("/patientregister");
    } else {
      setServerError(data.message || "Invalid login credentials.");
    }
  };

  return (
    <div className="staffloginpage-container">
      <header className="staffloginpage-header">
        <div className="staffloginpage-header-left">
          <ArrowLeft
            size={20}
            className="staffloginpage-backicon"
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          />
          <img src={logo} alt="Q-Less Logo" className="staffloginpage-logo" />
        </div>
      </header>

      <main className="staffloginpage-main">
        <div className="staffloginpage-card">
          <div className="staffloginpage-card-header">
            <Search size={38} className="staffloginpage-searchicon" />
            <h2>Staff Portal</h2>
            <p>Enter your credentials to access the hospital system</p>
          </div>

          <form className="staffloginpage-form" onSubmit={handleLogin}>
            {/* GLOBAL SERVER ERROR */}
            {serverError && (
              <p className="error-text" style={{ marginBottom: "10px" }}>
                {serverError}
              </p>
            )}

            <label htmlFor="role">Role</label>
            <select
              id="role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option>Doctor</option>
              <option>Receptionist</option>
            </select>

            <label htmlFor="cid">CID Number</label>
            <input
              id="cid"
              type="text"
              placeholder="Enter your CID"
              value={cid}
              onChange={(e) => {
                setCid(e.target.value);
                setCidError("");
              }}
            />
            {cidError && <p className="error-text">{cidError}</p>}

            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setEmailError("");
              }}
            />
            {emailError && <p className="error-text">{emailError}</p>}

            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordError("");
              }}
            />
            {passwordError && <p className="error-text">{passwordError}</p>}

            <button type="submit" className="staffloginpage-btn">
              Login
            </button>
          </form>
        </div>
      </main>

      <footer className="staffloginpage-footer">
        © 2025 Q-Less. All Rights Reserved.
      </footer>
    </div>
  );
}

export default RLogin
